<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-31 10:42:27
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:57:13
 * @Description: file content
 使用指南 模板
 -->

<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script>
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO",
    })
  },
  beforeCreate() {},
  created() {
    const that = this;
    if (
      util.queryCheck(
        {
          id: "PageId",
          psn: "防刷参数"
        },
        that.$route.query
      )
    ) {
      // 获取页面信息
      comreq
        .getPageInfo(that.$route.query.id, that.$route.query.psn, that)
        .then(function(pageInfo) {
          that.SET_PAGEINFO(pageInfo);
        });
      // 设置内容自行动
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        // 上报设备信息
        comreq.actMt(that);
      });
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.container {
}
</style>